import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { FormField, FormService } from "@shared/services/FormServices";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { Label } from "@shared/ui/label";
import { Switch } from "@shared/ui/switch";
import { FIELD_CLASSES } from "@shared/utils/constants";
import { usePutValidationRule, useValidationRules } from "../../hooks";
import { logEvent } from "@shared/analytics/analytics";

interface ValidationRulesDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ValidationRulesDialog = ({
  open,
  onClose,
}: ValidationRulesDialogProps) => {
  const remoteUtilityId = useRemoteUtilityId();

  const { data: validationRules } = useValidationRules(remoteUtilityId, open);
  const { mutate: updateValidationRule } = usePutValidationRule();

  const handleToggle = (ruleId: string, isActive: boolean) => {
    updateValidationRule({
      id: ruleId,
      payload: {
        is_active: !isActive,
      },
    });
    logEvent("Validation Rule Updated", {
      id: ruleId,
      isActive: !isActive,
    });
  };
  const createFormFields = (): FormField[] => [
    {
      name: "utility_service",
      label: "Utility Service",
      type: "select",
      tooltipText: "Filter VEE rules based on utility services",
      required: false,
      showHelperTooltip: true,
      placeholder: "Select Utility Service",
      options: [],
      classes: FIELD_CLASSES,
    },
    {
      name: "frequency",
      label: "Frequency",
      type: "select",
      required: false,
      tooltipText: "Frequency at which meter reading should be validated",
      placeholder: "Select Frequency",
      showHelperTooltip: true,
      options: [],
      classes: FIELD_CLASSES,
    },
  ];
  const form = FormService.createForm({
    fields: createFormFields(),
  });

  function handleFieldChange(fieldName: string, value: any): void {
    throw new Error("Function not implemented.");
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] lg:max-w-[700px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Validation Rules</DialogTitle>
          <DialogDescription>
            Enable or disable validation rules to control how readings are
            validated.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6 space-y-6">
          {/* <DynamicForm
            fields={createFormFields()}
            form={form}
            onFieldChange={handleFieldChange}
            config={{
              showSubmitButton: false, // We're using custom footer
              showResetButton: false, // We're using custom footer
              layout: "vertical",
              spacing: "medium",
            }}
            className="space-y-6"
            gridColumns={2}
            onSubmit={function (data: any): void | Promise<void> {
              throw new Error("Function not implemented.");
            }}
          /> */}
          {validationRules?.map((rule) => (
            <div key={rule.id} className="border rounded-md p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">{rule.label}</h3>
                  <p className="text-sm text-muted-foreground mt-1">
                    {rule.description}
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  <Label htmlFor={`${rule.id}-switch`} className="sr-only">
                    {rule.isActive ? "Enabled" : "Disabled"}
                  </Label>
                  <Switch
                    id={`${rule.id}-switch`}
                    checked={rule.isActive}
                    onCheckedChange={() =>
                      handleToggle(String(rule.id), rule.isActive)
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
